import React from "react";
import { Box, IconButton } from "@mui/material";
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import AddAPhotoOutlinedIcon from '@mui/icons-material/AddAPhotoOutlined';
import { picUrl } from "../../shared/picUrl";

export const ImageHandler = ({ allPics, handleDeletePic, handleFileChange }) => {
    return (
      <Box
        display="flex"
        alignItems="center"
        overflow="auto"
        flexWrap="wrap"
        border="1px solid"
        borderColor="rgba(0, 0, 0, 0.23)"
        borderRadius="4px"
      >
        {allPics.map((pic, index) => {
          const src = picUrl(pic);
          return (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            position="relative"
            m={0.5}
          >
            <a href={src} target="_blank" rel="noopener noreferrer">
              <img
                src={src}
                alt="uploaded pic"
                border="1px solid"
                style={{
                  width: "40px",
                  height: "40px",
                  objectFit: "cover",
                  borderColor: "rgba(0, 0, 0, 0.14)",
                  borderRadius: "4px"
                }}
              />
            </a>
            <IconButton
              color="error"
              size="small"
              sx={{ position: 'absolute', right: -8, top: -8 }}
              onClick={() => handleDeletePic(pic)}
            >
              <HighlightOffRoundedIcon />
            </IconButton>
          </Box>
          );
        })}
                <Box display="flex" alignItems="flex-start">
          <IconButton color="inherit" aria-label="upload picture" component="label">
            <input
              hidden accept="image/*"
              type="file"
              id="pics"
              multiple
              onChange={handleFileChange}
            />
            <AddAPhotoOutlinedIcon fontSize="medium" />
          </IconButton>
        </Box>
      </Box>
    );
  };

  